import { fetchConversations } from '../services/vibeCodingService';
import {
  createRequestId,
  matchesRequest,
} from '../../../features-v2/vibe-coding/utils/requestUtils';
import {
  VIBE_CODING_GET_CONVERSATIONS_BEGIN,
  VIBE_CODING_GET_CONVERSATIONS_SUCCESS,
  VIBE_CODING_GET_CONVERSATIONS_FAILURE,
  VIBE_CODING_GET_CONVERSATIONS_DISMISS_ERROR,
} from './constants';

export function getConversations(args = {}) {
  return async (dispatch) => {
    const requestId = createRequestId('vibe-conversations');
    dispatch({ type: VIBE_CODING_GET_CONVERSATIONS_BEGIN, meta: { requestId } });
    try {
      const data = await fetchConversations(args);
      dispatch({ type: VIBE_CODING_GET_CONVERSATIONS_SUCCESS, data, meta: { requestId } });
      return data;
    } catch (error) {
      dispatch({
        type: VIBE_CODING_GET_CONVERSATIONS_FAILURE,
        data: { error },
        meta: { requestId },
      });
      throw error;
    }
  };
}

export function dismissGetConversationsError() {
  return { type: VIBE_CODING_GET_CONVERSATIONS_DISMISS_ERROR };
}

export function reducer(state, action) {
  const meta = action.meta || {};
  switch (action.type) {
    case VIBE_CODING_GET_CONVERSATIONS_BEGIN:
      return {
        ...state,
        getConversationsPending: true,
        getConversationsError: null,
        activeConversationsRequestId: meta.requestId || state.activeConversationsRequestId,
      };
    case VIBE_CODING_GET_CONVERSATIONS_SUCCESS:
      if (!matchesRequest(state.activeConversationsRequestId, meta.requestId)) return state;
      return {
        ...state,
        getConversationsPending: false,
        getConversationsError: null,
        conversations: Array.isArray(action.data) ? action.data : [],
      };
    case VIBE_CODING_GET_CONVERSATIONS_FAILURE:
      if (!matchesRequest(state.activeConversationsRequestId, meta.requestId)) return state;
      return {
        ...state,
        getConversationsPending: false,
        getConversationsError: action.data.error,
      };
    case VIBE_CODING_GET_CONVERSATIONS_DISMISS_ERROR:
      return { ...state, getConversationsError: null };
    default:
      return state;
  }
}
